import { useState, useEffect } from "react";

// Hook to detect user's operating system
export function usePlatform() {
    const [platformName, setPlatformName] = useState<"Mac" | "Windows" | "Linux" | "Unknown">("Unknown");

    useEffect(() => {
        const platform = window.navigator.platform.toLowerCase();

        if (platform.includes("mac")) {
            setPlatformName("Mac");
        } else if (platform.includes("win")) {
            setPlatformName("Windows");
        } else if (platform.includes("linux")) {
            setPlatformName("Linux");
        } else {
            setPlatformName("Unknown");
        }
    }, []);

    return platformName;
}
